import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'

export interface EmojiOptions {
	HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		emoji: {
			/**
			 * Insert an emoji
			 */
			insertEmoji: (emoji: string) => ReturnType
		}
	}
}

export const Emoji = Extension.create<EmojiOptions>({
	name: 'emoji',

	addOptions() {
		return {
			HTMLAttributes: {},
		}
	},

	addCommands() {
		return {
			insertEmoji:
				(emoji: string) =>
				({ commands }) => {
					return commands.insertContent(emoji)
				},
		}
	},

	addProseMirrorPlugins() {
		return [
			new Plugin({
				key: new PluginKey('emoji'),
				props: {
					handleDOMEvents: {
						paste: (_view, _event) => {
							// Handle emoji paste events if needed
							return false
						},
					},
				},
			}),
		]
	},
})
